// extracted by mini-css-extract-plugin
export default {"mainContent":"layout_mainContent__cb2jh"};